var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 26 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00C8B0",
    d: "M0 3.24C0 1.45 1.587 0 3.545 0h18.91C24.412 0 26 1.45 26 3.24v20.52c0 1.79-1.587 3.24-3.546 3.24H3.546C1.587 27 0 25.55 0 23.76V3.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.636 7.56H2.364V6.48h21.272v1.08ZM23.636 20.52H2.364v-1.08h21.272v1.08ZM23.636 14.04H2.364v-1.08h21.272v1.08Z",
    clipRule: "evenodd"
  })));
};
export default SvgMenu;